import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { MohValidationErrors, DataService } from 'moh-package';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UtilitiesService {

  private banksList: any[];

  constructor(private dataService: DataService) { }

  streetPattern(pattern: RegExp, errorMessage: string): ValidatorFn {

    return (control: AbstractControl): MohValidationErrors | null => {

      let street: any = control.value;

      if (street) {

        if (typeof (street) == "object") {
          return null;
        }
        else {
          if (pattern.test(street)) {
            return null;
          }
          return {
            'StreetValidation': { errorMessage: errorMessage }
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/services/general/utilities.service.ts